import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ActivitiesContainer = styled.div`
  padding: ${spacing(32)} ${spacing(52)} ${spacing('xxl')} ${spacing(52)};

  @media ${media.maxWidth.md} {
    padding: ${spacing('xl')} ${spacing(28)} ${spacing('xxl')} ${spacing(28)};
  }

  @media ${media.maxWidth.sm} {
    padding: ${spacing('xl')};
  }
`;
